import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { ChangeStorymapName as ChangeStorymapNameCommand } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeStorymapName extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeStorymapName';

    public constructor(public name: string) {
        super(ChangeStorymapName.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeStorymapName): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new ChangeStorymapNameCommand(state.id, action.name)
    });
};

const reducer = (state: StorymapState, action: ChangeStorymapName): void => {
    state.name = action.name;
};

//@ts-ignore
registerMiddleware(ChangeStorymapName.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeStorymapName.ACTION_TYPE, reducer);
